"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var LayoutTypes;
(function (LayoutTypes) {
  LayoutTypes["General"] = "general";
  LayoutTypes["GeneralImage"] = "generalImage";
  LayoutTypes["GeneralV2"] = "generalV2";
  LayoutTypes["Avtokredity"] = "avtokredity";
  LayoutTypes["GeneralV2Image"] = "generalV2Image";
  LayoutTypes["GeneralV2WithComparison"] = "generalV2WithComparison";
  LayoutTypes["GeneralV2WithRedirect"] = "generalV2WithRedirect";
  LayoutTypes["Kursy"] = "kursy";
  LayoutTypes["CreditCardsAgentsWL"] = "creditCardsAgentsWL";
  LayoutTypes["GeneralV2WithImage"] = "generalV2WithImage";
  LayoutTypes["BookMakers"] = "bookMakers";
  LayoutTypes["BookMakersPopup"] = "bookMakersPopup";
  LayoutTypes["Credit"] = "credit";
  LayoutTypes["GeneralV2NoLogo"] = "generalV2NoLogo";
  LayoutTypes["OSGOP"] = "osgop";
  LayoutTypes["BiznesFranshizy"] = "biznesFranshizy";
})(LayoutTypes || (LayoutTypes = {}));
var _default = LayoutTypes;
exports.default = _default;